import React, { useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import IUser from '../user/user.interface'
import UserContext from '../user-context'

const User: React.FC<IUser> = ({ index, addNewChange, deleteRow }) => {
  const { contactUsers, setContactUsers } = useContext(UserContext)
  const { contactRoles } = useContext(UserContext)

  const updateRole = (value: any) => {
    addNewChange(contactUsers[index].id)
    const usersCopy = [...contactUsers]
    usersCopy[index]['contactRole'] = value
    setContactUsers(usersCopy)
  }

  const handleDelete = () => {
    if (
      window.confirm(`Är du säker på att du vill ta bort användaren: ${contactUsers[index].name}`)
    ) {
      deleteRow(contactUsers[index].id, index)
    }
  }

  return (
    <tr className="flex flex-row w-full">
      <td className="flex flex-row w-full gap-2">
        <select
          className="w-full input"
          defaultValue={contactUsers[index].contactRole}
          onChange={(e) => updateRole(e.target.value)}
        >
          {contactRoles
            ? Object.keys(contactRoles).map((contactRoleKey) => {
                return (
                  <option key={contactRoleKey} value={contactRoleKey}>
                    {contactRoles[contactRoleKey]}
                  </option>
                )
              })
            : null}
        </select>
        <button
          className="w-1/12 text-right"
          onClick={() => {
            handleDelete()
          }}
        >
          <FontAwesomeIcon icon={faTrash} color="#003D64" />
        </button>
      </td>
    </tr>
  )
}

export default User
